import React, { useState } from "react";
import {
    Form,
    Input,
    Button,
    Space,
    Select,
    Tag,
    AutoComplete,
    DatePicker,
    Tooltip,
    Checkbox,
} from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import Sidemenu from "../../components/sidemenu";
import Header from "../../components/header";
import Footer from "../../components/footer";
import QuestionDetails from "../../components/questionDetails";
import * as Styled from "./styled";
import { functionService } from "../../lib/functions";
import addImage from "../../images/added.svg";
import deleteImage from "../../images/deleted.svg";
import moment from "moment";
import ConfirmModal from "./modal";
import styles from "./styles.module.scss";

const { Option } = Select;

const AIInterViewForm = () => {
    const [form] = Form.useForm();
    const [emails, setEmails] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [skillOptions, setSkillOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedMasterSkillIds, setSelectedMasterSkillIds] = useState([]);
    const [selected, setSelected] = useState("");
    const [loading,setLoading]=useState(false)
    const numberValidator = (_, value) => {
        const isNumber = !isNaN(parseFloat(value)) && isFinite(value);
        if (!isNumber) {
            return Promise.reject("Please enter a valid number");
        }
        return Promise.resolve();
    };

    const handleSelect = (value, option, key) => {
        let obj = {
            skill: value,
        };
        const selectedOption = skillOptions.find((opt) => opt.name === value);
        if (selectedOption) {
            setSelectedMasterSkillIds((prevIds) => {
                return [...prevIds, selectedOption];
            });
        }
    };

    const showModal = () => {
        setOpen(true);
    };

    const onSearchSkill = async (text) => {
        let {
            response: {
                data: { data },
            },
        } = await functionService.post("machineinterview/skillsuggestion", {
            skill: text,
        });
        let result = data?.map((item) => ({
            master_skill_id: item.master_skill_id,
            name: item.name,
            value: item.name,
        }));

        setSkillOptions(result);
    };

    const validateFields = async () => {
        try {
            await form.validateFields();
        } catch (error) {
            console.error("Validation failed:", error);
        }
    };

    const handleTagAdd = () => {
        if (inputValue && !emails.includes(inputValue)) {
            setEmails([...emails, inputValue]);
            setInputValue("");
        }
    };
    const handleTagRemove = (tag) => {
        const updatedTags = emails.filter((t) => t !== tag);
        setEmails(updatedTags);
    };

    const onFinish = async (values) => {
        try {
            const startDate = values.startDate
                ? moment.utc(values.startDate["$d"]).format("YYYY-MM-DD")
                : null;
            const endDate = values.endDate
                ? moment.utc(values.endDate["$d"]).format("YYYY-MM-DD")
                : null;

            const newVal = {
                ...values,
                difficultyLevel: selected,
                startDate,
                endDate,
                skills: values?.skills,
            };
            setLoading(true)
            const {
                response: {
                    data: { data },
                },
            } = await functionService.post(
                "machineinterview/addAssessment",
                newVal
            );




            if (data?.test_id) {

                const { response } = await functionService.post(
                    "machineinterview/addInvitee",
                    {
                        email: emails,
                        test_id: data.test_id,
                    }
                );
            }
            form.resetFields();
            setLoading(false)
            showModal(true);
        } catch (error) {}
    };

    const onFinishFailed = (errorInfo) => {
        // console.log("Failed:", errorInfo);
    };
    const handleChange = (value) => {
        setSelected(value);
    };
    return (
        <Styled.MainDiv>
            <QuestionDetails />
            <Sidemenu />
            <Styled.ColumnDiv>
                <Header />

                <Styled.ContentWrapDiv>
                    <Styled.ContentDiv>
                        <Styled.HeaderWrapDiv>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                }}
                            >
                                <Styled.HeaderText>
                                    New Assessment
                                </Styled.HeaderText>
                                <Styled.FormContainer
                                    style={{
                                        display: "flex",
                                        // width: "70vw",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <Form
                                        name="myForm"
                                        onFinish={onFinish}
                                        onFinishFailed={onFinishFailed}
                                        onFieldsChange={() => {
                                            validateFields();
                                        }}
                                        layout="vertical"
                                    >
                                        <div
                                            style={{
                                                backgroundColor: "white",
                                                // margin: "0 30px",
                                                // padding: "10px 20px 10px 20px",
                                                borderRadius: "8px",
                                                width: "100%",
                                                padding: "30px 30px 10px 30px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: "50px",
                                                }}
                                            >
                                                <Form.Item
                                                    label="Title"
                                                    name="testTitle"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message:
                                                                "Please enter the test title!",
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder="Enter title here"
                                                        style={{
                                                            width: "400px",
                                                            height: "40px",
                                                        }}
                                                    />
                                                </Form.Item>

                                                <Form.Item
                                                    label="No. of Question"
                                                    name="totalquestions"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "",
                                                        },
                                                        {
                                                            validator:
                                                                numberValidator,
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        style={{
                                                            width: "400px",
                                                            height: "40px",
                                                        }}
                                                        placeholder="Enter no of questions"
                                                    />
                                                </Form.Item>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: "50px",
                                                }}
                                            >
                                                <Form.Item
                                                    label="Duration"
                                                    name="duration"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "",
                                                        },
                                                        {
                                                            validator:
                                                                numberValidator,
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        style={{
                                                            width: "400px",
                                                            height: "40px",
                                                        }}
                                                        placeholder="Enter duration (in minutes)"
                                                    />
                                                </Form.Item>

                                                <Form.Item
                                                    label="Difficulty Level"
                                                    name="difficultyLevel"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message:
                                                                "Please select the difficulty level!",
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        className={
                                                            styles.select_input
                                                        }
                                                        onChange={handleChange}
                                                        style={{
                                                            width: "400px",
                                                            height: "40px",
                                                        }}
                                                        placeholder="Select difficulty level"
                                                    >
                                                        <Option value="easy">
                                                            Easy
                                                        </Option>
                                                        <Option value="medium">
                                                            Medium
                                                        </Option>
                                                        <Option value="hard">
                                                            Hard
                                                        </Option>
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: "50px",
                                                }}
                                            >
                                                <Form.Item
                                                    label="Min Work Experience"
                                                    name="minExperience"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "",
                                                        },
                                                        {
                                                            validator:
                                                                numberValidator,
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        style={{
                                                            width: "400px",
                                                            height: "40px",
                                                        }}
                                                        placeholder="Enter min. work experience"
                                                    />
                                                </Form.Item>

                                                <Form.Item
                                                    label="Max Work Experience"
                                                    name="maxExperience"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "",
                                                        },
                                                        {
                                                            validator:
                                                                numberValidator,
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        style={{
                                                            width: "400px",
                                                            height: "40px",
                                                        }}
                                                        placeholder="Enter max. work experience"
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                backgroundColor: "white",
                                                margin: "20px 0px",
                                                padding: "30px 30px 10px 30px",
                                                borderRadius: "8px",
                                                width: "100%",
                                            }}
                                        >
                                            <Form.List
                                                name="skills"
                                                initialValue={[
                                                    { skill: "", noOfQues: "" },
                                                    { skill: "", noOfQues: "" },
                                                    { skill: "", noOfQues: "" },
                                                ]}
                                                rules={[
                                                    {
                                                        validator: async (
                                                            _,
                                                            names
                                                        ) => {},
                                                    },
                                                ]}
                                            >
                                                {(fields, { add, remove }) => (
                                                    <>
                                                        {fields.map(
                                                            ({
                                                                key,
                                                                name,
                                                                ...restField
                                                            },index) => (
                                                                <div

                                                                    key={key}
                                                                    style={{
                                                                        display:
                                                                            "flex",
                                                                        columnGap:
                                                                            "50px",
                                                                    }}
                                                                >
                                                                    <Form.Item

                                                                        {...restField}
                                                                        name={[
                                                                            name,
                                                                            "skill",
                                                                        ]}
                                                                        label="Skill"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message:
                                                                                    "Please enter the title",
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <AutoComplete
                                                                            className={styles?.autocompleteWrapper}
                                                                            style={{
                                                                                width: "400px",
                                                                            }}
                                                                            onSearch={
                                                                                onSearchSkill
                                                                            }
                                                                            options={
                                                                                skillOptions
                                                                            }
                                                                            onSelect={(
                                                                                value,
                                                                                option
                                                                            ) =>
                                                                                handleSelect(
                                                                                    value,
                                                                                    option,
                                                                                    key
                                                                                )
                                                                            }
                                                                            placeholder="input here"
                                                                        />
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        {...restField}
                                                                        name={[
                                                                            name,
                                                                            "noOfQues",
                                                                        ]}
                                                                        label="No of question"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message:
                                                                                    "",
                                                                            },
                                                                            {
                                                                                validator:
                                                                                    numberValidator,
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Input
                                                                            placeholder="Number of Question"
                                                                            style={{
                                                                                width: "400px",
                                                                                height: "40px",
                                                                            }}
                                                                        />
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        style={{
                                                                            marginTop:
                                                                                "30px",
                                                                            columnGap:
                                                                                "50px",
                                                                            display:
                                                                                "flex",
                                                                            justifyContent:
                                                                                "space-between",
                                                                        }}
                                                                    >
                                                                        {fields.length >
                                                                        1 ? (
                                                                            <img
                                                                                alt=""
                                                                                style={{
                                                                                    width: "30px",
                                                                                    height: "40px",
                                                                                    marginRight:"10px",cursor:"pointer"
                                                                                }}
                                                                                src={
                                                                                    deleteImage
                                                                                }
                                                                                onClick={() => {
                                                                                    remove(
                                                                                        name
                                                                                    );
                                                                                }}
                                                                            />
                                                                        ) : null}
                                                                       {fields.length < 5&&(fields.length-1===index) && (

                                                                <img
                                                                    alt=""
                                                                    src={
                                                                        addImage
                                                                    }
                                                                    style={{
                                                                        width: "30px",
                                                                        height: "40px",cursor:"pointer"
                                                                    }}
                                                                    onClick={() => {
                                                                        add();
                                                                    }}
                                                                />
                                                        )}
                                                                    </Form.Item>
                                                                </div>
                                                            )
                                                        )}

                                                    </>
                                                )}
                                            </Form.List>
                                        </div>
                                        <div
                                            style={{
                                                backgroundColor: "white",
                                                margin: "0px",
                                                padding: "5px 30px 10px 30px",
                                                borderRadius: "8px",
                                                width: "100%",
                                            }}
                                        >
                                            <p>Publish Assesment</p>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: "50px",
                                                }}
                                            >
                                                <Form.Item
                                                    label="Start Date"
                                                    name="startDate"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message:
                                                                "Please select start date!",
                                                        },
                                                        {
                                                            validator: (
                                                                _,
                                                                value
                                                            ) => {
                                                                const {
                                                                    endDate,
                                                                } =
                                                                    form.getFieldsValue(
                                                                        [
                                                                            "endDate",
                                                                        ]
                                                                    );
                                                                if (
                                                                    value &&
                                                                    endDate &&
                                                                    value.isAfter(
                                                                        endDate,
                                                                        "day"
                                                                    )
                                                                ) {
                                                                    return Promise.reject(
                                                                        "Start date must be before end date"
                                                                    );
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        },
                                                    ]}
                                                >
                                                    <DatePicker
                                                        style={{
                                                            width: "400px",
                                                            height: "40px",
                                                        }}
                                                    />
                                                </Form.Item>

                                                <Form.Item
                                                    label="End Date"
                                                    name="endDate"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message:
                                                                "Please select end date!",
                                                        },
                                                        {
                                                            validator: (
                                                                _,
                                                                value
                                                            ) => {
                                                                const {
                                                                    startDate,
                                                                } =
                                                                    form.getFieldsValue(
                                                                        [
                                                                            "startDate",
                                                                        ]
                                                                    );
                                                                if (
                                                                    value &&
                                                                    startDate &&
                                                                    value.isBefore(
                                                                        startDate,
                                                                        "day"
                                                                    )
                                                                ) {
                                                                    return Promise.reject(
                                                                        "End date must be after start date"
                                                                    );
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        },
                                                    ]}
                                                >
                                                    <DatePicker
                                                        style={{
                                                            width: "400px",
                                                            height: "40px",
                                                        }}
                                                    />
                                                </Form.Item>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginRight: "5px",
                                                    }}
                                                >
                                                    Candidate data
                                                </p>
                                                <Tooltip title="These details will be asked from the developers while giving the assessment.">
                                                    <InfoCircleFilled
                                                        color="#939599"
                                                        style={{
                                                            height: "1px",
                                                        }}
                                                    />
                                                </Tooltip>{" "}
                                            </div>
                                            <Form.Item name="options">
                                                <Checkbox.Group>
                                                    <Checkbox value="Name">
                                                        Name
                                                    </Checkbox>
                                                    <Checkbox value="Mobile Number">
                                                        Mobile Number
                                                    </Checkbox>
                                                    <Checkbox value="Photo Verification">
                                                        Photo Verification
                                                    </Checkbox>
                                                </Checkbox.Group>
                                            </Form.Item>
                                        </div>
                                        <div
                                            style={{
                                                backgroundColor: "white",
                                                margin: "20px 0px",
                                                padding: "30px 30px 10px 30px",
                                                borderRadius: "8px",
                                                width: "100%",
                                            }}
                                        >
                                            <Form.Item
                                                label="Invitee"
                                                name="emails"
                                                initialValue={emails}
                                                // rules={[
                                                //     {
                                                //         required: true,
                                                //         message:
                                                //             "Please enter eamils !",
                                                //     },
                                                // ]}
                                            >
                                                <Space
                                                    style={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "flex-start",
                                                        flexWrap: "wrap",
                                                        border: "1px solid #C8CACC",
                                                        alignItems:
                                                            "flex-start",
                                                        padding: "10px",
                                                    }}
                                                >
                                                    {emails.map((tag) => (
                                                        <Tag
                                                            style={{
                                                                display: "flex",
                                                                alignItems:
                                                                    "center",
                                                                fontSize:
                                                                    "11px",
                                                                fontWeight:
                                                                    "500",
                                                                borderColor:
                                                                    "#1B49EA",
                                                            }}
                                                            color="processing"
                                                            bordered={false}
                                                            key={tag}
                                                            closable
                                                            onClose={() =>
                                                                handleTagRemove(
                                                                    tag
                                                                )
                                                            }
                                                        >
                                                            {tag}
                                                        </Tag>
                                                    ))}
                                                    <Form.Item
                                                        style={{
                                                            height: "20px",
                                                            marginTop: "-5px",
                                                        }}
                                                    >
                                                        <Input
                                                            style={{
                                                                height: "20px",
                                                                width: "250px",
                                                                borderRadius:
                                                                    "6px",
                                                            }}
                                                            value={inputValue}
                                                            onChange={(e) =>
                                                                setInputValue(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            type="text"
                                                            size="small"
                                                            onPressEnter={
                                                                handleTagAdd
                                                            }
                                                            bordered={false}
                                                            placeholder="Enter addresses (comma separated)"
                                                        />
                                                    </Form.Item>
                                                </Space>
                                            </Form.Item>
                                        </div>
                                        <Styled.CreateBtnContainer
                                            style={{
                                                backgroundColor: "white",
                                                margin: "0px",
                                                padding: "20px",
                                                borderRadius: "8px",
                                                width: "100%",
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Form.Item>
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    disabled={loading}
                                                    style={{
                                                        backgroundColor:
                                                            "#1B49EA",
                                                    }}
                                                >
                                                    Create Assesment
                                                </Button>
                                            </Form.Item>
                                        </Styled.CreateBtnContainer>
                                    </Form>
                                </Styled.FormContainer>
                            </div>
                        </Styled.HeaderWrapDiv>
                    </Styled.ContentDiv>

                    <Footer />
                </Styled.ContentWrapDiv>
            </Styled.ColumnDiv>
            {<ConfirmModal isOpen={open} setOpen={setOpen} />}
        </Styled.MainDiv>
    );
};

export default AIInterViewForm;
